import { render, staticRenderFns } from "./ComponentsList.vue?vue&type=template&id=5bac5743&"
import script from "./ComponentsList.vue?vue&type=script&lang=js&"
export * from "./ComponentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports